module.exports = __webpack_public_path__ + "img/0040.ad9d6a4e.jpg";